/**
 * Vérifie si l'utilisateur courant peut modifier/supprimer un enregistrement.
 *
 * @param {Object} user - L'objet utilisateur courant (depuis localStorage)
 * @param {number} creatorId - L'ID de l'utilisateur qui a créé l'enregistrement
 * @returns {boolean} true si l'utilisateur peut modifier/supprimer
 */
export const canModifyRecord = (user, creatorId) => {
  if (!user) return false;

  const role = user.role?.toLowerCase();

  // L'entrenador ne peut modifier/supprimer que ses propres enregistrements
  if (role === 'entrenador') {
    return user.id === creatorId;
  }

  // Tous les autres rôles peuvent modifier/supprimer n'importe quel enregistrement
  return true;
};
